module.exports = __webpack_public_path__ + "static/media/chery2.bccd577b.png";